import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Drone from "@/components/site/Drone";
import QuoteGenerator from "@/components/site/QuoteGenerator";
import Coverage from "@/components/site/Coverage";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function Landing() {
  return (
    <div className="bg-[#0A0A0A] text-white">
      <Nav />
      <Hero />
      <Services />
      <Drone />
      <QuoteGenerator />
      <Coverage />
      <Contact />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
